export function SummaryRow({
  label,
  amount,
  emphasized = false,
}: {
  label: string
  amount: string
  emphasized?: boolean
}) {
  return (
    <div className={`flex items-center justify-between gap-4 ${emphasized ? 'font-medium' : ''}`}>
      <span>{label}</span>
      <span className="shrink-0 tabular-nums">{amount}</span>
    </div>
  )
}

import { formatMoneyCents } from '@/lib/money'

export function formatCents(cents: number, currency = 'USD') {
  return formatMoneyCents(cents, currency)
}

export function GiveDisclosures({ wording, footer }: { wording?: string; footer?: string }) {
  return (
    <div className="space-y-2 text-caption text-muted-foreground">
      <p>{wording ?? 'Loading tax details…'}</p>
      {footer && <p data-testid="give-disclosures-footer">{footer}</p>}
    </div>
  )
}

export function PublicGiveFeeCover({
  enabled,
  checked,
  cents,
  currency = 'USD',
  onChange,
}: {
  enabled: boolean
  checked: boolean
  cents: number
  currency?: string
  onChange: (value: boolean) => void
}) {
  if (!enabled) return null
  return (
    <label htmlFor="give-fee-cover" className="flex items-start gap-2 text-body-sm">
      <Checkbox
        id="give-fee-cover"
        checked={checked}
        onCheckedChange={(value) => onChange(value === true)}
      />
      <span>
        <span className="block text-foreground">
          Add {formatMoneyCents(cents, currency)} to cover card processing fees
        </span>
        <span className="block text-caption text-muted-foreground">
          Your gift and the estimated processing cost are charged as one donation.
        </span>
      </span>
    </label>
  )
}
import { Checkbox } from '@/components/ui/checkbox'
